import { render, staticRenderFns } from "./ClientProjectsList.vue?vue&type=template&id=eaa944da&"
import script from "./ClientProjectsList.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports